import React from "react"

import {PageContentInterface} from "../page-content-interface"
import AppControlMore from "../../../../../layout/app-controls/buttons/more/more"
import CoverSelector from "../../../../../core/gd-components/cover/cover-selector/control-button"
import AttachmentsCollection from "../../../../../core/model2/attachment/attachments"
import page_setCover from "../../actions/set-cover"
import AppControlShare from "../../../../../layout/app-controls/buttons/share/share"
import {MoreButtonOptionType} from "../../../../../layout/app-controls/buttons/more/standard-option"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../core/gd-components/buttons/control-button/control-button-standard"
import AppControlPageSettings from "./settings/page-settings"
import exportToPdf from "../../../../../core/gd-app/import-export/export-to-pdf"
import PageExportContainer from "../../pdf-version/pdf-version"
import RelatedItemsDocumentControlButton from "../../../../../core/gd-components/related-items/popover/document-control-button"

type Props = {
    app                 : PageContentInterface

    attachments?        : AttachmentsCollection

    onTogglePopover?    : {(value: boolean): void}
}

// const debug = "PageControlsContent"
const debug = false

export default function PageControlsContent(props:Props) {

    const onAddPage = () => {
        props.app.onAddPage?.()
    }

    const onCoverSelected = (cover: any) => {
        debug && console.log(debug, 'onCoverSelected', cover)
        page_setCover(cover)
    }

    const onExportToPDF = ():void => {
        debug && console.log(debug, 'onExportToPDF')

        gd.company.license.isPro ?
            exportToPdf(props.app,  {
                exportComponent: <PageExportContainer app={props.app}/>
            })
            :
            gd.modals.other.upgradeToPro(gd.companyId)
    }

    const project = gd.session.projects.get(props.app.projectId)!

    const viewMoreOptions = [
        {
            type    : MoreButtonOptionType.HELP,
            onClick : ()=>{gd.utils.openHelp('article.text.editor')}
        },
        {
            type    : MoreButtonOptionType.SHORTCUTS,
            onClick : ()=>{gd.utils.openHelp('article.text.editor.shortcuts')}
        },
        {
            type    : MoreButtonOptionType.EXPORT_PDF,
            onClick : onExportToPDF
        },
    ]

    const relations = props.app.document?.relations

    const showAddPage           = props.app.document?.pages.length === 1
    const showSettingsButton =   project.acl.canModifyViews

    return (
        <>
            {showAddPage &&
                <ControlButtonStandard className    = "page-control-button m-r-8"
                                       type         = {ControlButtonType.ADD_PAGE}
                                       hint         = 'Add page'
                                       isDisabled   = {!project.acl.canAddPage}
                                       onClick      = {onAddPage}/>}

            {showSettingsButton &&
                <AppControlPageSettings className   = "page-control-button"
                                        app         = {props.app}/>}

            <div className="separator"/>

            {relations &&
                <RelatedItemsDocumentControlButton
                    className       = "page-control-button m-r-8"
                    relations       = {relations}
                    canEdit         = {project.acl.hasFullAccess}
                    projectId       = {props.app.projectId}
                    onTogglePopover = {props.onTogglePopover}
                />
            }

            <CoverSelector enableAttachments    = {true}
                           className            = "page-control-button m-r-8"
                           attachments          = {props.attachments}
                           cover                = {props.app.document.cover}
                           disabled             = {!project.acl.canEditCover}
                           onSelect             = {onCoverSelected}
                           onTogglePopover      = {props.onTogglePopover}/>

            <AppControlShare className  = "page-control-button m-r-8"
                             app        = {props.app}/>

            <AppControlMore className       = "page-control-button"
                            options         = {viewMoreOptions}
                            onTogglePopover = {props.onTogglePopover}/>
        </>
    )
}